import {Component, Input} from '@angular/core';
import {ImageCropperInterface, ImageModalData} from '@models';
import {ImagePlaceholderComponent, ImageUploadModalComponent} from '@shared/components';
import {AbstractControl, FormControl} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-profile-image',
    imports: [MatIconModule, ImagePlaceholderComponent],
    templateUrl: './profile-image.component.html',
    styleUrls: ['./profile-image.component.scss']
})
export class ProfileImageComponent {
    @Input() isEdit: boolean = false;
    @Input() profileName: string = '';

    @Input('defaultImage') set defaultImage(data: {
        image: string;
        type: string;
    }) {
        const imageURl = data.image ? this.addRandomString(data.image) : null;
        this.imageControl.setValue(imageURl);
        this.imageType = data.type;
    }

    public imageType!: string;

    public imageFile = {file: null, name: '', cropped: ''};
    public imageDeleted: boolean = false;
    public imageControl: FormControl = new FormControl();
    private _imageReloaded: boolean = false;

    constructor(
        private _matDialog: MatDialog
    ) {
    }

    public openImageModal({
                              field,
                              height,
                              width,
                              imageType,
                          }: ImageModalData): void {
        const oldSrc = field.value;

        this._matDialog
            .open(ImageUploadModalComponent, {
                data: {
                    height,
                    width,
                    imageType,
                    imageUrl: oldSrc,
                },
            })
            .afterClosed()
            .subscribe({
                next: (v) => {
                    if (v && v.croppedImage) {
                        this.imageFile.file = v.file;
                        this.imageFile.name = v.fileName;
                        this.imageFile.cropped = v.croppedImage;
                        this.setFieldValue(field, v.croppedImage);
                        return;
                    }
                    if (v?.imageDeleted) {
                        this.removeImage();
                    }
                },
                error: () => {
                    field.setValue(oldSrc);
                }
            });
    }

    /**
     * Adds random string to url to prevent browser cashing
     * @param url - Image url
     */
    private addRandomString(url: string): string {
        return `${url}?cash=${new Date().getTime()}`;
    }

    private setFieldValue(field: AbstractControl, value: string): void {
        field.setValue(value);
        field.markAsTouched();
    }

    public removeImage(): void {
        this.imageControl.setValue(null);
        this.imageFile = {file: null, name: '', cropped: ''};
        this.imageDeleted = true;
    }

    public reloadImage(imageForm: AbstractControl): void {
        if (!this._imageReloaded) {
            const changedImage = `${imageForm.value}?t=${new Date().getTime()}`;
            imageForm.setValue(changedImage);
        }
        this._imageReloaded = true;
    }

    public getData(): ImageCropperInterface {
        const imageDeleted = this.imageDeleted;
        const cropped = this.imageFile.cropped;

        this.imageDeleted = false;
        this._imageReloaded = false;
        return {
            image: this.imageFile.file,
            image_deleted: imageDeleted,
            cropped,
        };
    }
}
